import { h } from 'preact';

import StandardHomeEditor from 'components/editor/movies/home/standard/homeStandard';

// Only used in Universal Movie Platform
export default (props) => <StandardHomeEditor {...props} />;